import React from "react"

import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ListItemText from "@mui/material/ListItemText";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import FormControl from "@mui/material/FormControl";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";


const options = [
    {
        value: "default",
        element:
            <ListItem disablePadding divider>
                <ListItemAvatar><Avatar src="img/livignoitaly-icon-2.png" variant="square" sx={{ width: 35, height: 35 }}/></ListItemAvatar>
                <ListItemText primary="LivignoItaly"
                              secondary="Utilizza il server di posta di Livignotaly per l'invio delle email"/>
            </ListItem>
    },
    {
        value: "gmail",
        element:
            <ListItem disablePadding divider>
                <ListItemAvatar><Avatar src="img/gmail-icon.png" variant="square" sx={{ width: 35, height: 35 }}/></ListItemAvatar>
                <ListItemText primary="Gmail" secondary="Utilizza Gmail per l'invio delle email"/>
            </ListItem>
    },
    {
        value: "smtp",
        element:
            <ListItem disablePadding>
                <ListItemAvatar><Avatar sx={{ width: 35, height: 35 }}>S</Avatar></ListItemAvatar>
                <ListItemText primary="Altro (SMTP)" secondary="Utilizza un server SMTP per l'invio delle email"/>
            </ListItem>
    },
]

const EmailProvidersRadioList = (props) => {
    const {
        value = "default",
        onChange = f => f,
        onClickSelected = f => f,
        isLoading,
        providers = ["default", "gmail", "smtp"],
    } = props;

    return <Stack spacing={2}>
        <Typography>
            Seleziona il servizio email che verrà utilizzato per inviare le email ai tuoi ospiti
        </Typography>
        {
            isLoading ?
                <Stack>
                    <Skeleton height="56px"/>
                    <Skeleton height="56px"/>
                    <Skeleton height="56px"/>
                </Stack>
                :
                <FormControl component="fieldset" sx={{width: "100%"}}>
                    <RadioGroup
                        key="emailProvider"
                        aria-label={"email-provider"}
                        name={"emailProvider"}
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        sx={{width: "100%"}}
                    >
                        {
                            options
                                .filter(option => providers.find(p => option.value === p))
                                .map(({element, value}, i) => (
                                    <FormControlLabel key={i} label={element} value={value} control={<Radio/>}
                                                      disableTypography onClick={() => onClickSelected(value)}/>
                                ))
                        }
                    </RadioGroup>
                </FormControl>
        }

    </Stack>
}

export default EmailProvidersRadioList;